<template>
  <div class="ComplaintManage">
    <el-divider content-position="left">支付宝交易投诉列表</el-divider>
    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选">
        <div style="padding: 10px">
          <el-row class="mb-20 search-row" :gutter="20">
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>投诉/交易单号</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-input
                v-model="searchArr.order_num"
                size="mini"
                clearable
                placeholder="关键词:投诉单号、交易单号"
              ></el-input>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>投诉时间</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-date-picker
                size="mini"
                v-model="searchArr.complaint_date"
                type="daterange"
                :picker-options="assignPicker"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>投诉状态</span></el-col>
            <el-col :xs="24" :sm="8" :md="5" :lg="6">
              <el-select
                v-model="searchArr.status"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option :value="1" label="待处理"></el-option>
                <el-option :value="2" label="已处理"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="tr">
            <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
            <el-button type="danger" size="mini" @click="handleASearClear"
              >清除</el-button
            >
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-table :data="complaintOrders" size="medium">
      <el-table-column label="投诉单号" width="80">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.complaint_nun" placement="top">
            <span class="hide-style">{{ scope.row.complaint_nun }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="投诉时间" width="100">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.complaint_date" placement="top">
            <span class="hide-style">{{ scope.row.complaint_date }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="投诉金额" width="80">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.complaint_amount" placement="top">
            <span class="hide-style">{{ scope.row.complaint_amount }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="交易单号" width="150">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.trade_num" placement="top">
            <span class="hide-style">{{ scope.row.trade_num }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="投诉状态" width="60">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <span v-if="scope.row.status === 1" class="hide-style">待处理</span>
            <span v-else class="hide-style">已处理</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="投诉内容" width="150">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.complaint_content" placement="top">
            <span class="hide-style">{{ scope.row.complaint_content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="投诉处理" placement="top">
            <el-button
              :type="scope.row.status === 1 ? 'info' : 'success'"
              :icon="scope.row.status === 1 ? 'el-icon-edit-outline' : 'el-icon-check'"
              size="mini"
              circle
              @click="handelComplaint(scope.$index, scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        layout="sizes, total, prev, pager, next, jumper"
        :total="pageOption.total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="pageOption.pageSize"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComplaintManage",
  data() {
    return {
      activeOpen: "",
      complaintOrders: [],
      searchArr: {
        order_num: "",
        complaint_date: "",
        status: "",
      },
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      assignPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterDate = this.yesterday();
              picker.$emit("pick", yesterDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/complaint/lists?page=" +
            this.pageOption.currentPage +
            "&pagesize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.complaintOrders = data.data.complaintOrders;
            this.pageOption.total = data.data.complaintOrders.total;
          }
        });
    },
    handleASearSub() {
      this.activeOpen = "";
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    handleASearClear() {
      this.searchArr.order_num = "";
      this.searchArr.complaint_date = "";
      this.searchArr.status = "";
      this.activeOpen = "";
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handelComplaint(index, row) {
      this.$axios.put("/api/admin/refund/refundComplete/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var i = 0; i < this.pageData.length; i++) {
            if (row.id === this.pageData[i].id) {
              this.pageData[i].refund_status = 3;
            }
          }
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    prevWeek() {
      var end = new Date();
      var start = new Date();
      var lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);

      return [start, end];
    },
    today() {
      return [new Date(), new Date()];
    },
    yester() {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);

      return [date, date];
    },
    thisMon() {
      var end = new Date();
      var start = new Date();
      // 方法1
      var endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    lastMon() {
      var end = new Date();
      var start = new Date();
      var year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      var febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天

      return [start, end];
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.handelGetOrders();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.ComplaintManage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.ComplaintManage >>> .el-timeline-item__node--normal
  left: 0
.ComplaintManage >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.ComplaintManage
  marginLeft()
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.ComplaintManage >>> .el-table th>.cell
  padding-left: .28rem
.el-select, .el-cascader
  width: 100%
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-card__body p
  margin-top: .4rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.mt-50
  margin-top: 1rem
.mb-10
  margin-bottom: .2rem
.mb-20
  margin-bottom: .4rem
.ml-10
  margin-left: .2rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.search-row .el-col
  margin-bottom: .2rem
.el-date-editor
  width: 100% !important
.check-succ
  color: #67C23A
.bottom-btn
  padding: .2rem
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/complaint_manage/ComplaintManage.vue